import axios from "axios";

export const legsService = {
    /** Legs */
    getLegsService: (params) =>
        axios.get("/legs", {auth: true, params: {...params}}),
    addLegsService: (body) => axios.post("/legs", body, {auth: true}),

    deleteLegService: (id, params) =>
        axios.delete(`/legs/${id}`, {auth: true, params: {...params}}),

    cancelLegService: (id, data) =>
        axios.patch(`/legs/${id}/cancel`, data, {auth: true}),

    unCancelLegService: (id, data) =>
        axios.patch(`/legs/${id}/unCancel`, data, {auth: true}),

    noShowLegService: (id, data) =>
        axios.patch(`/legs/${id}/noShow`, data, {auth: true}),

    unNoShowLegService: (id, data) =>
        axios.patch(`/legs/${id}/unNoShow`, data, {auth: true}),

    getLegsTotalsService: (params) =>
        axios.get("/legs/totals", {auth: true, params: {...params}}),

    legAssigneeOrChangeDataService: (id, body) =>
        axios.patch(`/legs/${id}/table`, body, {auth: true}),

    acceptPendingLegsService: (body) =>
        axios.patch(`/legs/accept`, body, {auth: true}),

    rejectPendingLegsService: (body) =>
        axios.patch(`/legs/reject`, body, {auth: true}),

    /** Trips */
    getSingleTripService: (id, params) =>
        axios.get(`/legs/trip/${id}`, {auth: true, params: {...params}}),

    editTripService: (id, body) =>
        axios.patch(`/legs/trip/${id}`, body, {auth: true}),

    deleteTripService: (id, params) =>
        axios.delete(`/legs/trip/${id}`, {auth: true, params: {...params}}),

    cancelTripService: (id, data) =>
        axios.patch(`/legs/trip/${id}/cancel`, data, {auth: true}),

    unCancelTripService: (id, data) =>
        axios.patch(`/legs/trip/${id}/unCancel`, data, {auth: true}),


    recalculateTripRevenue: (id, data) =>
        axios.patch(`/legs/trip/${id}/calculate`, data, {auth: true}),

    calculateDistance: (body) => axios.post(`/legs/distance/calculate`, body, {auth: true}),

    /** Repeat weekly */
    repeatWeeklyService: (data) => axios.post(`/legs/many`, data, {auth: true}),

    /** CSV */

    uploadLegCsv: (file, type) => axios.post(`/legs/csv/import`, file, {
        auth: true, params: {
            type,
        }
    }),

    // getLegsCSVService: (params) => axios.get("/legs/export/csv", {auth: true, params: {...params}}),

    /**Leg Notes */

    createLegNoteService: (legId, body) =>
        axios.post(`/legs/${legId}/note`, body, {auth: true}),

    editLegNoteService: (legId, noteId, body) =>
        axios.post(`/legs/${legId}/note/${noteId}`, body, {auth: true}),

    deleteLegNoteService: (legId, noteId) =>
        axios.patch(`/legs/${legId}/note/${noteId}/remove`, {},{auth: true}),

    /**End */

    getCsv: (url, params) => axios.get(url, {auth: true, params: {...params}}),
};
